import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { selectEntity } from '../../selectors/policy/selectEntity';
import { selectPolicySummary } from '../../selectors/policy/selectPolicySummary';
import { waitForPolicyStatusChangeSaga } from '../policy/waitForPolicyStatusChangeSaga';

export function* chargeCardSaga() {
    try {
        yield put(reduceLoading({ code: 'chargeCard', value: true }));
        const session = yield getSessionSaga();
        // Read once and hold it. The wait below spans seconds, and the entity in the store belongs
        // to whichever policy is on screen — polling it live would compare another policy's status.
        const entity = yield select(selectEntity());
        const summary = yield select(selectPolicySummary());
        const statusBefore = summary?.status;

        const response = yield call(fetch, `/api/payment/capture-authorization/${entity}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        yield put(reduceOperation(result.operation));

        // A refusal is the server's answer, not a failure to get one, and it arrives with a reason
        // attached. Reloading here would wipe that reason off the screen before it could be read,
        // leaving a card that silently did not get charged.
        //
        // Only an explicit `false` counts. `Operation.Status` is nullable, and treating an absent
        // status as a refusal would turn the button into a no-op: no reload, no message, nothing.
        if (result.operation?.status === false) {
            return;
        }

        // Charging starts work that outlives the request, so the page is reloaded once the record
        // has moved rather than immediately. The reload itself is kept — it is what re-fetches the
        // documents and payment records the charge produces, whose tabs load once on mount and
        // would otherwise still show the state from before the money went through.
        yield call(waitForPolicyStatusChangeSaga, entity, statusBefore);
        window.location.reload();
    } catch (error) {
        console.log('Error while calling Charge Card API - ', error);
        yield put(
            reduceOperation({
                status: false,
            }),
        );
    } finally {
        yield put(reduceLoading({ code: 'chargeCard', value: false }));
    }
}
